<img *ngIf="linkToSvg$ | async as linkToSvg" [ngSrc]="linkToSvg" [width]="width" [height]="height" class="qr-code" alt="qrCode">